import ActiveInitialTermModule from '@/models/ActiveInitialTermModule'
import Company from '@/models/Company'
import MediaKpiModule from '@/models/MediaKpiModule'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'
import simpleCard from '@/pages/ManagementDashboard/scripts/simple-card'
import moment from 'moment'
import numeral from 'numeral'

export default class ProfitOverviewCards extends SystemDashboardWidget {
  public key: string = 'profit-overview-custom-widget'

  public view = 'custom'

  public size = {
    lg: 12,
    md: 12,
    sm: 12,
  }

  public groups = {
    view: 'region',
  }

  public dataSourceRequest: any = null

  constructor(args: any = null) {
    super()

    if (args && args.dimensions) {
      this.dimensions = args.dimensions
    }

    if (args && args.metrics) {
      this.metrics = args.metrics
    }

    if (args && args.filters) {
      this.filters = Object.assign(this.filters, args.filters)
    }
    if (args && args.internalFilters) {
      this.internalFilters = Object.assign(this.internalFilters, args.internalFilters)
    }

    if (args && args.rightCol) {
      this.rightCol = args.rightCol
    }

    if (args && args.leftCol) {
      this.leftCol = args.leftCol
    }

    if (args && args.size) {
      this.size = args.size
    }

    if (args && args.title) {
      this.title = args.title
    }

    if (args && args.key) {
      this.key = args.key
    }

    if (args && args.updateFields) {
      this.fields = args.updateFields(this.fields)
    }

    if (args && args.internalQuery) {
      this.internalQuery = args.internalQuery
    }

    if (args && args.internalQueryPush) {
      if (!this.internalQuery) this.internalQuery = []
      this.internalQuery.push(args.internalQueryPush)
    }

    if (args && args.dataSourceRequest) {
      this.dataSourceRequest = args.dataSourceRequest
    }
  }

  public get filterToQuery() {
    let query = []

    if (this.filters.product !== 'all') {
      query.push(`product:${this.filters.product}`)
    }

    if (this.filters.region !== 'all') {
      query.push(`region:${this.filters.region}`)
    }

    if (this.filters.special_group !== 'all') {
      query.push(`special_group:${this.filters.special_group}`)
    }

    // query.push(`year:${this.filters.start}`)

    query.push(`start:${moment(this.filters.start).format('YYYY-MM-DD')}`)
    query.push(`end:${moment(this.filters.end).format('YYYY-MM-DD')}`)

    return query
  }

  public get payload() {
    const query = [...new Set([...this.query, ...this.internalQuery, ...this.filterToQuery])]

    return {
      query,
      start: this.filters.start,
      end: this.filters.end,
    }
  }

  public dataSource() {
    if (this.dataSourceRequest) {
      const res = this.dataSourceRequest(this.payload)
      return res.then((r: any) => {
        if (r.hasOwnProperty('records')) {
          this.records = r.records
        }

        if (r.result) return r.result

        return r.data
      })
    }

    let request = new MediaKpiModule()
    return request.overview(this.payload).then((r: any) => {
      if (r.result) return r.result

      return r.data
    })
  }

  public get customData() {
    let data = this.rawData
    let ytd_revenue = numeral(data.ytd_revenue || 0).format('$0.00a')
    let ytd_erpm = numeral(data.ytd_erpm || 0).format('$0.00a')
    let ytd_cost = numeral(data.ytd_cost_ecpm || 0).format('$0.00a')
    let ytd_cost_wo_mo = numeral(data.ytd_cost_ecpm_wo_mo || 0).format('$0.00a')
    let total_planned_imps = numeral(data.total_planned_impressions || 0).format('0a')
    if (isNaN(data.total_planned_impressions)) {
      total_planned_imps = 'N/A'
    }
    let total_delivered = numeral(data.total_delivered || 0).format('0a')

    return `
    <div class="row text-center mt-5">
      <div class="col">
        <h6>YTD RPM</h6>
        <h4 class='text-primary'>${ytd_revenue}</h4>
      </div>
      <div class="col">
        <h6>YTD eRPM</h6>
        <h4 class='text-primary'>${ytd_erpm}</h4>
      </div>
      <div class="col">
        <h6>YTD Cost CPM (w/o MO)</h6>
        <h4 class='text-danger'>${ytd_cost_wo_mo}</h4>
      </div>
      <div class="col">
        <h6>YTD Cost eCPM (w MO)</h6>
        <h4 class='text-danger'>${ytd_cost}</h4>
      </div>
      <div class="col">
        <h6>Total Planned Imps (Sold)</h6>
        <h4>${total_planned_imps}</h4>
      </div>
      <div class="col">
        <h6>Total Delivered</h6>
        <h4>${total_delivered}</h4>
      </div>
    </div>
    <div class="row mt-5">
        <div class="col">
            <small>* Yesterday, MTD is based on calendar. Quarter and YTD will be a blend of actual recognized + estimate (both revenue and cost).</small>
            <br>
            <small>* <strong>Planned Impressions can not be filtered by MLB vs Non MLB, It represents Network impressions</string></small>
        </div>
    </div>
    `
  }
}
